import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Vérifier périodiquement si le token est toujours valide
    const checkTokenValidity = () => {
      const tokenExpiry = localStorage.getItem('tokenExpiry');
      const now = new Date().getTime();

      if (tokenExpiry && now > parseInt(tokenExpiry)) {
        // Token expiré - déconnecter et rediriger
        logout();
      }
    };

    // Vérifier immédiatement
    checkTokenValidity();

    // Vérifier toutes les 30 secondes
    const interval = setInterval(checkTokenValidity, 30000);

    return () => clearInterval(interval);
  }, [logout]);

  // Afficher un loader pendant la vérification
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.5rem'
      }}>
        Vérification de l'authentification...
      </div>
    );
  }

  // Rediriger vers login si non authentifié
  if (!isAuthenticated) {
    // Sauvegarder l'URL demandée pour rediriger après connexion
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Utilisateur authentifié - afficher le contenu
  return children;
};

export default ProtectedRoute;
